import { render, staticRenderFns } from "./file-dropdown.vue?vue&type=template&id=4dd9254d"
import script from "./file-dropdown.vue?vue&type=script&lang=js"
export * from "./file-dropdown.vue?vue&type=script&lang=js"
import style0 from "./file-dropdown.vue?vue&type=style&index=0&id=4dd9254d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports